import type { BookingEventReportDto } from '../Types/bookingEventReport.types';
import { bookingsApi } from './bookingsApi';
import { TagTypes } from '../../../Api/Types/tagTypes';

export const bookingEventReportApi = bookingsApi.injectEndpoints({
  endpoints: (builder) => ({
    getBookingEventReport: builder.query<BookingEventReportDto, number>({
      query: (bookingId) => `/bookings/${bookingId}/event-report`,
      providesTags: (_result, _error, bookingId) => [{ type: TagTypes.Booking, id: bookingId }],
    }),
  }),
});

export const { useGetBookingEventReportQuery } = bookingEventReportApi;
